module.exports = __webpack_public_path__ + "img/improved-safety-standards.b0215b6b.svg";